<!-- <div class="outerPadding">
  <ion-item mode="md" style="border: 1px solid #F4F5F8; border-radius: 10px ;">
    <ion-label  position="floating" [ngStyle]="{color: themeservice.theme.primaryColor }" *ngIf="label && !mandatoryError" class="font0_9">{{label}}</ion-label>
    <ion-label  position="floating" class="validationError " *ngIf="isMandatory">{{mandatoryError}} </ion-label>
    <ion-input  [type]="type" [minlength]="minlength" [maxlength]="maxlength" (keyup.enter)="keyEnter()" (keypress)="numericOnly($event)" [(ngModel)]="variable" (ionBlur)="checkMandatory()"
      (ionChange)="editInput()">
      <ion-icon slot="end" [name]="icon" *ngIf="icon"></ion-icon>
    </ion-input>
  </ion-item>
</div> -->

<div class="padding5">
  <ion-textarea mode="md" [minlength]="minlength" [maxlength]="maxlength" [disabled]='disabled' [label]="label"
    labelPlacement="floating" (keyup.enter)="keyEnter()" [autoGrow]="true" [type]="type" [placeholder]="label"
    (ionChange)="editInput()" [(ngModel)]="variable" fill='outline'></ion-textarea>
</div>